<template>
  <div>
    <shared-view-task></shared-view-task>
  </div>
</template>

<script>
import SharedViewTask from '@/views/Shared/Tasks/View'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Window.Task.View',
  components: {
    SharedViewTask
  },
  mounted () {
    EventBus.$emit('initViewTaskModal', { id: this.$route.params.id })
  }
}
</script>

<style scoped>

</style>
